export const analyticsEvent = (type: string, title: string, event: any) => ({
  type: `DDA_${type}`,
  payload: event,
  meta: {
    title,
  },
});
